import { createComponent } from '@carvana/merch-components';
import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import styled from 'styled-components';
import HeartWithBorder from '~/icons/HeartWithBorder';
import HeartWithBorderThin from '~/icons/HeartWithBorderThin';
import ShareIcon from '~/icons/Share';
import ShareIconAlt from '~/icons/ShareAlt';

export const ActionsContainer = createComponent('div', {
  className: 'flex items-center gap-16'
});

export const ShareButtonAlt = createComponent(ShareIconAlt, {
  className: 'pointer-events-auto flex h-16 w-16  m:h-24 m:w-24'
});

export const ShareButton = createComponent(ShareIcon, {
  className: 'pointer-events-auto flex h-20  m:h-28'
});

export const Heart = styled(HeartWithBorder).attrs({
  className: 'pointer-events-auto'
})`
  @media screen and (min-width: ${legacyBreakpoints.m}px) {
    height: 18px;
    width: 18px;
  }

  .svg-heart {
    stroke: #000;
  }

  &.big-heart {
    height: 22px;
    width: 22px;
  }
`;

export const ThinHeart = styled(HeartWithBorderThin).attrs({
  className: 'pointer-events-auto'
})`
  height: 18px;
  width: 18px;

  @media screen and (min-width: ${legacyBreakpoints.m}px) {
    height: 24px;
    width: 24px;
  }

  .svg-heart {
    stroke: #000;
  }
`;
